import { render, staticRenderFns } from "./purchaseRemits.vue?vue&type=template&id=07e90216&scoped=true&"
import script from "./purchaseRemits.vue?vue&type=script&lang=js&"
export * from "./purchaseRemits.vue?vue&type=script&lang=js&"
import style0 from "./purchaseRemits.vue?vue&type=style&index=0&lang=css&"
import style1 from "./purchaseRemits.vue?vue&type=style&index=1&id=07e90216&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e90216",
  null
  
)

export default component.exports